var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 10.168C17.54 9.64797 17.4933 9.14797 17.4067 8.66797H10.5V11.508H14.4467C14.2733 12.4213 13.7533 13.1946 12.9733 13.7146V15.5613H15.3533C16.74 14.2813 17.54 12.4013 17.54 10.168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 17.3318C12.4798 17.3318 14.1398 16.6784 15.3531 15.5584L12.9731 13.7118C12.3198 14.1518 11.4865 14.4184 10.4998 14.4184C8.59312 14.4184 6.97313 13.1318 6.39313 11.3984H3.95312V13.2918C5.15979 15.6851 7.63312 17.3318 10.4998 17.3318Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39464 11.3948C6.24797 10.9548 6.1613 10.4882 6.1613 10.0015C6.1613 9.51484 6.24797 9.04818 6.39464 8.60818V6.71484H3.95464C3.45464 7.70151 3.16797 8.81484 3.16797 10.0015C3.16797 11.1882 3.45464 12.3015 3.95464 13.2882L5.85464 11.8082L6.39464 11.3948Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 5.58797C11.5798 5.58797 12.5398 5.9613 13.3065 6.6813L15.4065 4.5813C14.1331 3.39464 12.4798 2.66797 10.4998 2.66797C7.63312 2.66797 5.15979 4.31464 3.95312 6.71464L6.39312 8.60797C6.97312 6.87464 8.59312 5.58797 10.4998 5.58797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b473df24d84671111d1f13aebb051318.svg";
export { ForwardRef as ReactComponent };